import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loadingSales': false,
  'salesList': [],
  'downloading': false,
  'loadingWalkIn': false,
  'walkIn': [],
};

export const dailyVehiclesSalesAndStock = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DAILY_VEHICLES_SALES]: (state, action) => ({
      ...state,
      'loadingSales': true,
    }),
    [ActionTypes.FETCHED_DAILY_VEHICLES_SALES]: (state, action) => ({
      ...state,
      'loadingSales': false,
      'salesList': action.response.data,
    }),
    [ActionTypes.FETCHED_DAILY_VEHICLES_SALES_FAILED]: (state, action) => ({
      ...state,
      'loadingSales': false,
      'salesList': [],
    }),
    [ActionTypes.DOWNLOADING_DAILY_VEHICLES_SALES]: (state) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES]: (state) => {
      downloadFile(action.response.data);

      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES_FAILED]: (state) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.FETCHING_WALK_IN]: (state) => ({
      ...state,
      'loadingWalkIn': true,
    }),
    [ActionTypes.FETCHED_WALK_IN]: (state) => ({
      ...state,
      'loadingWalkIn': false,
      'walkIn': action.response.data,
    }),
    [ActionTypes.FETCHED_WALK_IN_FAILED]: (state) => ({
      ...state,
      'loadingWalkIn': false,
      'walkIn': [],
    }),
  })(state, action);
};
